<div
  class="flex justify-content-around flex-wrap h-screen align-content-center">
  <form class="p-fluid" [formGroup]="twoFactorForm" (ngSubmit)="onSubmit()">
    <div class="p-card p-5 w-30rem shadow-3">
      <app-header
        styleClass="m-0 p-0 text-2xl mb-4"
        icon="fas fa-shield-alt"
        text="Zwei-Faktor-Authentifizierung"></app-header>
      <div>
        <p class="text-color-secondary mb-4">
          Bitte geben Sie den 6-stelligen Sicherheits-Code ein, den wir Ihnen
          per E-Mail gesendet haben.
        </p>

        @if (store.error()) {
          <app-alert
            severity="error"
            [header]="error.summary"
            [canToggle]="false"
            styleClass="mb-4"
            [text]="store.error()?.message || ''">
          </app-alert>
        }

        <div class="flex flex-column gap-2 mb-4 w-full">
          <label for="code" class="font-bold">Sicherheits-Code</label>

          <div class="flex gap-3">
            <p-inputOtp
              [mask]="pwMasked"
              id="code"
              [length]="6"
              formControlName="code"></p-inputOtp>
            <p-button
              [outlined]="true"
              (click)="pwMasked = !pwMasked"
              [icon]="pwMasked ? 'fas fa-eye' : 'fas fa-eye-slash'"></p-button>
          </div>

          @if (submitted && twoFactorForm.get('code')?.errors?.['pattern']) {
            <small class="p-error">Bitte geben Sie genau 6 Ziffern ein.</small>
          }
        </div>
        <p-divider />
      </div>

      <div class="flex">
        <p-button
          [rounded]="true"
          severity="secondary"
          icon="fas fa-times"
          label="Abbrechen"
          [text]="true"
          (click)="cancel()"
          type="button">
        </p-button>
        <p-button
          class="ml-auto"
          [loading]="store.loading()"
          [rounded]="true"
          icon="fas fa-check"
          label="Verifizieren"
          type="submit">
        </p-button>
      </div>
    </div>
  </form>
</div>
